/**
 * Industry Data Module
 *
 * Purpose: Contains industry sector requirements and training units
 * Data Source: fss_requirements_by_industry.csv, fss_requirements_by_industry_updated.csv
 * Usage: IndustrySelector component, calculation engine
 */

const industryData = {
  hospitalityRetail: {
    id: 'hospitalityRetail',
    name: 'Hospitality & Retail',
    description: 'Restaurants, cafes, takeaways, hotels, catering',
    unitsRequired: ['SITXFSA005', 'SITXFSA006'],
    alternativeUnits: ['SIRRFSA001'],
    skillSetCode: 'SITSS00069',
    category: 'Category 1 & 2',
    stateAvailability: 'All',
    vulnerablePopulation: false,
    highRisk: true,
    specialNotes: 'Most common certification; covers restaurants, cafes, takeaways, hotels, catering',
    stateExceptions: {}
  },

  healthCommunity: {
    id: 'healthCommunity',
    name: 'Health & Community Services',
    description: 'Hospitals, childcare centres, school canteens',
    unitsRequired: ['HLTFSE001', 'HLTFSE005', 'HLTFSE007'],
    alternativeUnits: [],
    skillSetCode: 'HLTSS00061',
    category: 'Category 1',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'Serves vulnerable populations; stricter requirements',
    stateExceptions: {}
  },

  foodProcessing: {
    id: 'foodProcessing',
    name: 'Food Processing & Manufacturing',
    description: 'Food processing plants, breweries, wineries',
    unitsRequired: ['FBPFSY1002', 'FBPFSY2002'],
    alternativeUnits: ['SITXFSA005', 'SITXFSA006'],
    skillSetCode: 'Food Processing specific',
    category: 'Category 1',
    stateAvailability: 'VIC, QLD',
    vulnerablePopulation: false,
    highRisk: true,
    specialNotes: 'Manufacturing/processing focus; VIC & QLD specific units',
    stateExceptions: {
      VIC: { available: true },
      QLD: { available: true },
      OTHER: {
        available: false,
        useAlternative: true,
        alternativeUnits: ['SITXFSA005', 'SITXFSA006'],
        note: 'FBPFSY units not available in your state. SITX units recommended.'
      }
    }
  },

  agedCareLicensed: {
    id: 'agedCareLicensed',
    name: 'Aged Care (Licensed)',
    description: 'Licensed aged care facilities',
    unitsRequired: ['HLTFSE001', 'HLTFSE005', 'HLTFSE007'],
    alternativeUnits: [],
    skillSetCode: 'HLTSS00061',
    category: 'Category 1',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'Written Food Safety Program required; Standard 3.2.2A compliance',
    additionalRequirements: ['Written Food Safety Program required'],
    stateExceptions: {
      NSW: {
        note: 'HLTFSE units not accepted in NSW for licensed aged care; must use written Food Safety Program',
        requiresWrittenProgram: true
      }
    }
  },

  agedCareNonLicensed: {
    id: 'agedCareNonLicensed',
    name: 'Aged Care (Non-Licensed)',
    description: 'Non-licensed aged care facilities',
    unitsRequired: ['SITXFSA005', 'SITXFSA006'],
    alternativeUnits: ['SITXFSA001'],
    skillSetCode: 'SITSS00069',
    category: 'Category 1 or 2',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'Must check licensing status with NSW Food Authority',
    stateExceptions: {
      NSW: {
        note: 'Only SITX units accepted by NSW Food Authority for non-licensed aged care',
        unitsRequired: ['SITXFSA005', 'SITXFSA006']
      }
    }
  },

  childcare: {
    id: 'childcare',
    name: 'Childcare/Early Learning',
    description: 'Childcare centres and early learning facilities',
    unitsRequired: ['HLTFSE001', 'HLTFSE005', 'HLTFSE007'],
    alternativeUnits: [],
    skillSetCode: 'HLTSS00061',
    category: 'Category 1',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'Vulnerable population; mandatory FSS under Standard 3.2.2A',
    stateExceptions: {}
  },

  schoolsCanteens: {
    id: 'schoolsCanteens',
    name: 'Schools/Canteens',
    description: 'School canteens and food service',
    unitsRequired: ['HLTFSE001', 'HLTFSE005', 'HLTFSE007'],
    alternativeUnits: [],
    skillSetCode: 'HLTSS00061',
    category: 'Category 1',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'School canteens now require FSS under updated regulations',
    stateExceptions: {}
  },

  healthcare: {
    id: 'healthcare',
    name: 'Healthcare/Hospitals',
    description: 'Hospitals and healthcare facilities',
    unitsRequired: ['HLTFSE001', 'HLTFSE005', 'HLTFSE007'],
    alternativeUnits: [],
    skillSetCode: 'HLTSS00061',
    category: 'Category 1',
    stateAvailability: 'All',
    vulnerablePopulation: true,
    highRisk: true,
    specialNotes: 'High-risk environment; vulnerable patients',
    stateExceptions: {}
  }
};

export default industryData;
